/**
 * @description  宽屏幕layout，目前主要用在宽屏幕上, 类似pc的页面
 * @author duanjun
 */

import BasicLayout from './basicLayout';
import { IData, IOptions } from './interface';
import version from './partial/version';

// 这个地方的html 是webpack处理的， 不能用ts语法，当然也可以把html改成ts模块。这样会造成语法高亮丢失。
import renderSentryReportWithVersion from './partial/sentry';
import titlePart from './partial/title';
import reportPart from './partial/report';
import metaPart from './partial/meta';
import bootPart from './partial/boot';
import es6ShimPart from './partial/es6Shim';
import loadingPart from './partial/loading';
import analysisPart from './partial/analysis';
import monitorPart from './partial/monitor';
import debuggerNodePart from './partial/debugger.node';
import reportSpyPart from './partial/reportSpy';
import qrcodeSdk from './partial/qrcode';

class WidePageLayout<T extends IData = IData, K extends IOptions = IOptions> extends BasicLayout<T, K> {
    constructor(data: T, options: K) {
        super(data, options);
    }

    public renderTitle() {
        return titlePart();
    }

    public renderMeta() {
        return metaPart();
    }

    /**
     * @description 不能留空格
     */
    public renderPageData() {
        return `
            <script type="text/template" id="__pageDataTemplate__">{{pageData | jsonsafe}}</script>
        `;
    }

    public renderHeaderCss() {
        let cssPart = '{{source.globalCss | default("") | safe}}\n';
        this.options.css.forEach((path: string) => {
            cssPart += `<link href="${path}" rel="stylesheet" /> \n`;
        });
        return cssPart;
    }

    public renderFooterScript() {
        let scriptPart = '{{source.globalJs | default("") | safe}}\n';
        this.options.js.forEach((path) => {
            scriptPart += `<script type="text/javascript" src="${path}"></script> \n`;
        });
        return scriptPart;
    }

    public renderHeaderScrit() {
        return '';
    }

    public renderHeader() {
        let isRenderMonitor = true;
        let isBootPart = true;
        if (this.options.partialConfig) {
            if (this.options.partialConfig.monitor === false) {
                isRenderMonitor = false;
            }
            if (this.options.partialConfig.boot === false) {
                isBootPart = false;
            }
        }
        return `
            ${es6ShimPart(this.data)}
            ${super.renderHeader()}
            ${this.renderTitle()}
            ${this.renderMeta()}
            ${this.renderHeaderCss()}
            ${this.renderHeaderScrit()}
            ${debuggerNodePart()}
            ${isBootPart ? bootPart(this.data) : ''}
            ${isRenderMonitor ? monitorPart(this.data) : ''}
            ${this.useSentry ? renderSentryReportWithVersion(this.data, this.SYSTEM) : reportPart(this.data)}
        `;
    }

    public renderContent() {
        const data = this.data;
        return `<div class="doc-wide ${data.pageClassName || ''}">
            ${loadingPart()}
        </div>`;
    }

    public renderFooter() {
        let isRenderAnalysis = true;
        if (this.options.partialConfig) {
            if (this.options.partialConfig.analysis === false) {
                isRenderAnalysis = false;
            }
        }
        return `
            ${this.renderPageData()}
            ${qrcodeSdk(this.data)}
            ${this.renderFooterScript()}
            ${this.useSentry ? '' : reportSpyPart()}
            ${isRenderAnalysis ? analysisPart(this.data): ''}
            ${version(this.data.VERSION)}
        `;
    }

    public render() {
        return super.render();
    }
}

export default WidePageLayout;
